import { StyleSheet, View, Modal, ActivityIndicator } from "react-native";
import variables from "src/common/assets/variables";
import Text from "./text";

type SizeProp = "small" | "large" | undefined;

const Loader = ({
  loading = false,
  modal = true,
  color = variables.$brandColor,
  full = false,
  size = "large" as SizeProp,
  message = "",
}) => {
  const Indicator = <ActivityIndicator color={color} size={size} />;
  if (!modal) {
    if (full) {
      return (
        <View style={styles.full}>
          {Indicator}
          {!!message && <Text style={styles.message}>{message}</Text>}
        </View>
      );
    }
    return Indicator;
  }
  return (
    <Modal animationType="fade" transparent={true} visible={loading}>
      <View style={styles.root}>{Indicator}</View>
      {!!message && <Text style={styles.message}>{message}</Text>}
    </Modal>
  );
};

const styles = StyleSheet.create({
  root: {
    flex: 1,
    justifyContent: "center",
    backgroundColor: "#00000080",
  },
  full: {
    position: "absolute",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    pointerEvents: "none",
  },
  message: {
    fontSize: 16,
    color: "#636E72",
    marginTop: 20,
  },
});

export default Loader;
